import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/app-modals',
            component: { render: () => h(RouterView) },
            children: [
                {
                    path: '/app-modals',
                    name: 'app modals',
                    component: () => import("./views/appModals.vue")
                }
            ]
        }
    ];
};